import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  Form,
  Icon,
  Input,
  Button,
  Card,
  Row,
  Col,
  Layout,
} from 'antd';

import { withFirebase } from 'services/firebase';
import * as ROUTES from 'config/constants/routes';

import { saveUser } from 'redux/auth';

const { Header, Content } = Layout;


class Login extends React.Component {
  state = { error: '' }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (err) return;
      const { username, password } = values;

      try {
        await this.props.firebase.auth.signInWithEmailAndPassword(username, password)
        const user = this.props.firebase.userData();

        this.setState({ err: '' });
        this.props.saveUser(user);
        this.props.history.push(ROUTES.CHAT);
      }
      catch (error) {
        let errorMessage;
        if (error.code === 'auth/wrong-password') {
          errorMessage = 'Wrong password.';
        }
        else {
          errorMessage = error.message;
        }

        this.setState({ error: errorMessage })
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Layout
        style={{
          height:"100vh",
          'backgroundImage': 'linear-gradient(to right bottom, rgb(255, 255, 255), rgb(247, 249, 255), rgb(234, 245, 255), rgb(217, 241, 255), rgb(198, 239, 255))',
          'backgroundSize': 'cover'
        }}
      >
        <Header style={{background:"rgba(255, 255, 255, 0)"}}>
          <a href='https://www.convodo.io'>
            <img
              src={require('assets/images/logo-with-text.svg')}
              style={{height:"3em"}}
              alt="convodo logo"
            />
          </a>
        </Header>
        <Content
          style={{
            height:"100%",
            background:"rgba(255, 255, 255, 0)"
          }}
        >
        <Row type="flex" justify="center" align="middle" style={{height:"100%"}}>
          <Col xs={22} sm={16} md={12} lg={8} xl={6} >

            <Form onSubmit={this.handleSubmit} className="login-form">

            <Card
              className="login-card"
              style={{'boxShadow':'0 10px 15px -3px rgba(0,0,0,.1), 0 4px 6px -2px rgba(0,0,0,.05)'}}
            >
                <h1>Sign in to Convodo</h1>

                <Form.Item>
                  {getFieldDecorator('username', {
                    rules: [{ required: true, message: 'Please input your email' }],
                  })(
                    <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />
                  )}
                </Form.Item>

                <Form.Item>
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please input your password' }],
                  })(
                    <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                  )}
                </Form.Item>

                <Form.Item>
                  <p className="form-error">{this.state.error}</p>

                  <Button type="primary" htmlType="submit" size="large" className="login-form-button" shape="round">
                    Sign in
                  </Button>

                  Or <a href={ROUTES.SIGN_UP}>create an account!</a>
                </Form.Item>
              </Card>
            </Form>

          </Col>
        </Row>
        </Content>
      </Layout>
    );
  }
}

export default compose(
  withFirebase,
  connect(null, { saveUser }),
  Form.create({ name: 'login_form' }),
)(Login);
